// Google Analytics and Google Ads integration via Google Tag Manager
import { trackEvent, trackPageView } from './tagManager';

/**
 * Initialize Google Analytics
 * @param {string} trackingId - The Google Analytics tracking ID
 */
export const initGA = (trackingId) => {
  if (!trackingId) {
    console.warn('Google Analytics tracking ID is required');
    return;
  }

  // Push GA configuration to dataLayer
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      'ga-tracking-id': trackingId,
      'ga-config': {
        'anonymize_ip': true,
        'cookie_expires': 63072000, // 2 years in seconds
        'send_page_view': false // We'll handle this manually
      }
    });
  }

  // Log initialization in development
  if (process.env.NODE_ENV !== 'production') {
    console.log(`Google Analytics initialized with ID: ${trackingId}`);
  }
};

/**
 * Initialize Google Ads
 * @param {string} conversionId - The Google Ads conversion ID
 */
export const initGoogleAds = (conversionId) => {
  if (!conversionId) {
    console.warn('Google Ads conversion ID is required');
    return;
  }

  // Push Google Ads configuration to dataLayer
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      'google-ads-id': conversionId
    });
  }

  // Log initialization in development
  if (process.env.NODE_ENV !== 'production') {
    console.log(`Google Ads initialized with ID: ${conversionId}`);
  }
};

/**
 * Track page view
 * @param {string} path - The page path
 */
export const pageview = (path) => {
  trackPageView(path);
};

/**
 * Track event
 * @param {Object} params - Event parameters
 */
export const event = ({ action, category, label, value }) => {
  trackEvent('ga_event', {
    event_action: action,
    event_category: category,
    event_label: label,
    event_value: value
  });
};